import LegalShell, { Section } from "@/components/LegalShell";

const Privacy = () => {
  return (
    <div data-testid="privacy-page">
      <LegalShell title="Privacy Policy" updated="June 2026">
        <p className="text-zinc-400 leading-relaxed">
          IndieLaunchkit ("we", "us", "our") is committed to protecting your privacy and complying with the EU General
          Data Protection Regulation (GDPR) and the California Consumer Privacy Act (CCPA). This policy explains what data
          we collect, why we collect it, and the rights you have over it.
        </p>

        <Section heading="1. Data We Collect">
          <ul className="list-disc pl-5 space-y-2">
            <li><span className="text-zinc-200">Email address</span> — provided via Google sign-in, used to create and identify your account.</li>
            <li><span className="text-zinc-200">Account profile</span> — your name and profile picture as supplied by Google OAuth.</li>
            <li><span className="text-zinc-200">Essential session cookies</span> — a secure, httpOnly cookie that keeps you signed in. We do not use advertising or third-party tracking cookies.</li>
            <li><span className="text-zinc-200">Generated content & history</span> — the inputs you submit and the outputs our tools generate, stored so you can revisit your history.</li>
          </ul>
        </Section>

        <Section heading="2. Legal Basis for Processing (GDPR)">
          <p>
            We process your personal data on the basis of (a) the performance of our contract with you to provide the
            service, and (b) your consent, which you provide at sign-up and via our cookie banner. You may withdraw
            consent at any time.
          </p>
        </Section>

        <Section heading="3. Payments & Taxes — Merchant of Record">
          <p>
            All payments, sales tax, and VAT are processed by <span className="text-zinc-200">Paddle</span>, acting
            as our Merchant of Record. When you purchase a subscription, Paddle collects and processes your payment
            and billing information under their own privacy policy. We never see or store your full card details.
          </p>
        </Section>

        <Section heading="4. How We Use Your Data">
          <p>To operate the service, authenticate you, save your generation history, respond to support requests, and comply with legal obligations. We do not sell your personal data.</p>
        </Section>

        <Section heading="5. Data Retention">
          <p>We retain your account data for as long as your account is active. Session tokens expire after 7 days. You may request deletion at any time, after which we remove your account and associated generation history.</p>
        </Section>

        <Section heading="6. Your Rights">
          <ul className="list-disc pl-5 space-y-2">
            <li>Right to access the personal data we hold about you.</li>
            <li>Right to rectification of inaccurate data.</li>
            <li><span className="text-zinc-200">Right to erasure ("right to be forgotten")</span> — request full deletion of your account and data.</li>
            <li>Right to data portability and to restrict or object to processing.</li>
            <li>Right (CCPA) to know what data is collected and to opt out of any sale of data (we do not sell data).</li>
          </ul>
          <p>To exercise any right, email us at <a href="mailto:contact@getindielaunchkit.com" className="text-teal-300 hover:text-teal-300 underline underline-offset-2">contact@getindielaunchkit.com</a>.</p>
        </Section>

        <Section heading="7. Data Security">
          <p>We use industry-standard security including encrypted transport (HTTPS), httpOnly secure cookies, and access controls. No method of transmission is 100% secure, but we work to protect your data.</p>
        </Section>

        <Section heading="8. Contact">
          <p>
            Questions or data requests? Contact our data controller at{" "}
            <a href="mailto:contact@getindielaunchkit.com" className="text-teal-300 hover:text-teal-300 underline underline-offset-2" data-testid="privacy-contact-email">
              contact@getindielaunchkit.com
            </a>.
          </p>
        </Section>
      </LegalShell>
    </div>
  );
};

export default Privacy;
